import axios from 'axios';
import * as R from 'ramda'

class modelInputService {

    constructor() {
        let session = localStorage.getItem("FOM_user");
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL,
            token: (session ? JSON.parse(session).userdata.token : null),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${(session ? JSON.parse(session).userdata.token : null)}`
            }
        }
    }

    saveApplyModel(params) {
        return axios.put(this.state.apiUrl + "model/apply", params,
            {
                headers: this.state.headers
            })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }

    UploadModelInpuFile(data) {
        return axios.post(this.state.apiUrl + "model/upload", data)
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }

    UploadActualsInpuFile(data) {
        return axios.post(this.state.apiUrl + "home/uploadActuals", data)
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            });
    }

    getAllVariableGroups() {
      return axios.get(this.state.apiUrl + "model/allVariableGroups")
          .then(R.pathOr([], ['data', 'data']))
          .then(R.indexBy(R.prop('variableGroup')))
    }

}


export default modelInputService;
